import { OrderTypes } from 'shell/constants/order-types';
import { Order } from 'shell/view-models/order';

export function requestSort<K extends string | number | symbol>(
  property: K,
  orders: Order | undefined
): Order {
  let newOrders = (orders || {}) as Order;
  const keyOrder: K | undefined = (Object.keys(newOrders) as Array<K>).find(
    (order) => order === property
  );
  const isAsc = !!keyOrder && (newOrders[keyOrder] as OrderTypes) === OrderTypes.Asc;
  const orderType = isAsc ? OrderTypes.Desc : OrderTypes.Asc;

  if (!!keyOrder) {
    const key = keyOrder as K;
    const isDesc = (newOrders[keyOrder] as OrderTypes) === OrderTypes.Desc;
    newOrders = {
      ...orders,
      [key]: isDesc ? undefined : orderType,
    };
  } else {
    newOrders = {
      ...orders,
      [property]: orderType,
    };
  }
  return newOrders;
}
